const List = () => import("./components/List.vue");

export default [
  {
    path: "warehouseExit/list",
    name: "warehouse-exit-list",
    component: List,
    meta: { title: "Warehouse Exit" },
  },
  {
    path: "warehouseExit",
    redirect: { name: "warehouse-exit-list" },
  },
];
